module.exports = __webpack_public_path__ + "assets/img/mask-wealth-long.b76c1094.png";